import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    WORLD_CHANGING_IDEAS_PAGE_LOADING() {
      return {
        isLoading: true,
        worldChangingIdeasPage: action.worldChangingIdeasPage
      };
    },
    WORLD_CHANGING_IDEAS_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'world-changing-ideas',
        'categoryPage'
      );

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/best-workplaces-for-innovators';
      return {
        isLoading: false,
        data: action.worldChangingIdeasPage,
        ads: adModelData
      };
    },
    WORLD_CHANGING_IDEAS_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.worldChangingIdeasPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
